// Date range chip helpers — SHRS uses Mon-Sat week
export function isoDate(d) { return d.toISOString().slice(0, 10); }

export function todayRange() { const t = new Date(); return { from: isoDate(t), to: isoDate(t) }; }
export function thisWeekRange() {
  const t = new Date();
  const dow = (t.getDay() + 6) % 7; // Mon=0
  const mon = new Date(t); mon.setDate(t.getDate() - dow);
  const sat = new Date(mon); sat.setDate(mon.getDate() + 5);
  return { from: isoDate(mon), to: isoDate(sat) };
}
export function daysBack(n) { const t = new Date(); const f = new Date(t); f.setDate(t.getDate() - (n - 1)); return { from: isoDate(f), to: isoDate(t) }; }
export function monthsBack(m) { const t = new Date(); const f = new Date(t); f.setMonth(t.getMonth() - m); return { from: isoDate(f), to: isoDate(t) }; }

export const DEFAULT_RANGES = [
  { key: 'today', label: 'Today', get: todayRange },
  { key: 'week', label: 'This Week', get: thisWeekRange },
  { key: '7d', label: '7 days', get: () => daysBack(7) },
  { key: '15d', label: '15 days', get: () => daysBack(15) },
  { key: '30d', label: '30 days', get: () => daysBack(30) },
];
